export const SET_CONTEXTUAL_APP_BAR = 'HOME/SET_CONTEXTUAL_APP_BAR'
